<div *ngIf="person" class="profile person-profile">
  <div class="shadow-bottom">
    <div class="profile-details container">
      <div class="profile-info">
        <h1>
          <span>{{ name }} <sup hcfFootnote [footnoteText]="person.notes" *ngIf="person.notes"></sup></span>
          <span
            *ngIf="person.isAffiliatedProvider"
            class="ic-status-affiliated"
            title="An Affiliated Provider will organise prior approval with
 us and claim on your behalf for eligible healthcare
 services - so you don't need to submit a claim. You
 may need to see an Affiliated Provider in order to be
 covered under your policy."></span>
          <span *ngIf="person.isConsultant" class="is-consultant" title="{{ settings.values.consultIconTitle }}"></span>
          <span
            *ngIf="person.isTelehealth"
            class="is-telehealth"
            title="{{ settings.values.virtualConsultationTitle }}"></span>
        </h1>
        <h3 class="specialty">{{ person.specialist }}</h3>
        <div class="special-interests" *ngIf="person.specialInterest">
          Special interest(s): {{ person.specialInterest }}
        </div>
        <ul class="plain-list">
          <li
            class="ic-phone"
            *ngFor="let phone of person.phones"
            [innerHTML]="phone.number | phoneLinkedWithDescription: phone.description"
            aria-label="Phone"></li>
        </ul>
        <div class="ic-fax" *ngIf="person.fax" aria-label="Fax">
          {{ person.fax }}
        </div>
        <div class="ic-email" *ngIf="person.emailAddress" aria-label="Email">
          <a href="mailto:{{ person.emailAddress }}">{{ person.emailAddress }}</a>
        </div>
        <div class="ic-web" *ngIf="person.webAddress">
          <a href="{{ person.webAddress }}" target="_blank">{{ person.webAddress | webAddress }}</a>
        </div>
        <p class="report-problem">
          <a (click)="reportProblem()" class="cursor-pointer">Report incorrect details</a>
        </p>
      </div>
      <h3 [ngClass]="{ 'map-toggle': true, 'panel-expanded': mapExpanded }" (click)="toggleMap()">
        <span>View map</span>
      </h3>
      <!--ngIf is needed otherwise map is not initialised when hidden with css by default-->
      <hcf-map
        [places]="locations"
        [ngClass]="{
          'profile-map toggle-panel': true,
          'panel-expanded': mapExpanded,
        }"
        *ngIf="mapExpanded"></hcf-map>
    </div>

    <div class="container" *ngIf="person.isAffiliatedProvider">
      <div class="profile-details-message">
        <div class="profile-details-message-icon">
          <span class="ic-status-affiliated"></span>
        </div>
        <div class="profile-details-message-text">
          <strong class="reminder-content-ap-content-align"> Affiliated Providers (AP) </strong>
          <div>
            Below are the healthcare facilities where this AP works and the healthcare services they are contracted with
            us to perform at each healthcare facility. When booking, please confirm that the AP is contracted with us to
            perform the healthcare service at your chosen healthcare facility.
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="profile-extras container">
    <hcf-person-service-category
      *ngFor="let serviceCategoryName of personServiceCategoryNamesByPlace; let i = index"
      [serviceCategoryName]="serviceCategoryName"
      [placeDetails]="person.places"
      [componentIndex]="i"
      [numberOfServiceCategories]="person.serviceCategoryNames ? person.serviceCategoryNames.length : 0">
    </hcf-person-service-category>

    <div *ngIf="!person.serviceCategoryNames || person.serviceCategoryNames.length == 0">
      <!--If service category is not defined then show this-->
      <hcf-place-detail *ngFor="let place of person.places" [placeDetail]="place" class="place-detail">
      </hcf-place-detail>
    </div>

    <hcf-footnotes [footnotes]="footnotes" *ngIf="footnotes && footnotes.length > 0"></hcf-footnotes>
  </div>
</div>
<hcf-popup #reportProblemPopupComponent>
  <hcf-report-form [person]="person" [personFullName]="name" [place]=""></hcf-report-form>
</hcf-popup>
